// Tipos para o Dashboard - usados com dados reais do Supabase

export interface ClientesPorStatus {
  status: string;
  statusKey: string;
  quantidade: number;
  cor: string;
}

export interface TempoMedio {
  dia: string;
  tempoMedio: number;
}

export interface DesempenhoAtendente {
  id: string;
  nome: string;
  atendidos: number;
  finalizados: number;
  perdidos: number;
  tempoMedio: number;
  emAndamento: number;
}

import type { TFunction } from 'i18next';

// Configuração de status para manter consistência visual
export interface StatusConfigItem {
  key: string;
  label: string;
  cor: string;
}

export const STATUS_CONFIG_COLORS = [
  { key: 'novo', cor: 'hsl(217, 91%, 60%)' },
  { key: 'em_qualificacao', cor: 'hsl(48, 96%, 53%)' },
  { key: 'aguardando_atendente', cor: 'hsl(25, 95%, 53%)' },
  { key: 'em_atendimento', cor: 'hsl(142, 71%, 45%)' },
  { key: 'finalizado', cor: 'hsl(220, 9%, 46%)' },
  { key: 'perdido', cor: 'hsl(0, 84%, 60%)' },
  { key: 'voltar_contato', cor: 'hsl(271, 91%, 65%)' },
] as const;

export const getStatusConfig = (t: TFunction): StatusConfigItem[] => [
  { key: 'novo', label: t('clients.status.new'), cor: 'hsl(217, 91%, 60%)' },
  { key: 'em_qualificacao', label: t('clients.status.qualifying'), cor: 'hsl(48, 96%, 53%)' },
  { key: 'aguardando_atendente', label: t('clients.status.awaitingAgent'), cor: 'hsl(25, 95%, 53%)' },
  { key: 'em_atendimento', label: t('clients.status.inService'), cor: 'hsl(142, 71%, 45%)' },
  { key: 'finalizado', label: t('clients.status.finished'), cor: 'hsl(220, 9%, 46%)' },
  { key: 'perdido', label: t('clients.status.lost'), cor: 'hsl(0, 84%, 60%)' },
  { key: 'voltar_contato', label: t('clients.status.followUp'), cor: 'hsl(271, 91%, 65%)' },
];

// Funções utilitárias para cálculos
export function calcularTotalClientes(dados: ClientesPorStatus[]): number {
  return dados.reduce((acc, item) => acc + item.quantidade, 0);
}

export function calcularTaxaConversao(dados: ClientesPorStatus[]): number {
  const total = calcularTotalClientes(dados);
  const finalizados = dados.find(d => d.statusKey === 'finalizado')?.quantidade || 0;
  return total > 0 ? Math.round((finalizados / total) * 100) : 0;
}

export function calcularTempoMedioGeral(dados: TempoMedio[]): number {
  const dadosComValor = dados.filter(d => d.tempoMedio > 0);
  if (dadosComValor.length === 0) return 0;
  const soma = dadosComValor.reduce((acc, item) => acc + item.tempoMedio, 0);
  return Math.round((soma / dadosComValor.length) * 10) / 10;
}

export function calcularClientesAguardando(dados: ClientesPorStatus[]): number {
  const aguardando = dados.find(d => d.statusKey === 'aguardando_atendente')?.quantidade || 0;
  const novos = dados.find(d => d.statusKey === 'novo')?.quantidade || 0;
  return aguardando + novos;
}
